import { create } from "zustand";
import type { Blueprint } from "../pages/blueprint/useBlueprintQuery";

type AppState = {
  autoSwitch: boolean;
  setAutoSwitch: (autoSwitch: boolean) => void;

  matchInventory: boolean;
  setMatchInventory: (matchInventory: boolean) => void;

  autoTerraform: boolean;
  setAutoTerraform: (autoTerraform: boolean) => void;

  activeObjectTypeId: number;
  setActiveObjectTypeId: (activeObjectTypeId: number) => void;

  terraformBuildable: boolean;
  setTerraformBuildable: (terraformBuildable: boolean) => void;

  terraformMineable: boolean;
  setTerraformMineable: (terraformMineable: boolean) => void;

  terraformSize: number;
  setTerraformSize: (terraformSize: number) => void;

  terraformedObjects: Blueprint;
  setTerraformedObjects: (terraformedObjects: Blueprint) => void;
};

export const useAppStore = create<AppState>((set) => ({
  autoSwitch: false,
  setAutoSwitch: (autoSwitch) => set({ autoSwitch }),

  matchInventory: false,
  setMatchInventory: (matchInventory) => set({ matchInventory }),

  autoTerraform: false,
  setAutoTerraform: (autoTerraform) => set({ autoTerraform }),

  activeObjectTypeId: 0,
  setActiveObjectTypeId: (activeObjectTypeId) =>
    set({
      activeObjectTypeId,
      terraformBuildable: activeObjectTypeId === 0 || activeObjectTypeId !== 1,
      terraformMineable: activeObjectTypeId === 1,
    }),

  terraformBuildable: true,
  setTerraformBuildable: (terraformBuildable) =>
    set({
      terraformMineable: !terraformBuildable,
      terraformBuildable,
      activeObjectTypeId: 0,
    }),

  terraformMineable: false,
  setTerraformMineable: (terraformMineable) =>
    set({
      terraformBuildable: !terraformMineable,
      terraformMineable,
      activeObjectTypeId: 1,
    }),

  terraformSize: 10,
  setTerraformSize: (terraformSize) => set({ terraformSize }),

  terraformedObjects: [],
  setTerraformedObjects: (terraformedObjects) =>
    set((state) => ({
      terraformedObjects: [...state.terraformedObjects, ...terraformedObjects],
    })),
}));
